"use strict";
require('../../layouts/web')